<template>
  <div class="text-center">
    <text class="titulo-svg">
      Principales autoridades
    </text>
  </div>

  <div class="container-wrapper">
    <div class="container" v-for="(persona, index) in personas" :key="index" :class="{
      active: activo === index,
      first: index === 0,
      last: index === personas.length - 1
    }" @click="toggleSecciones(index)">
      <div class="seccion1" v-show="activo === -1 || activo === index">
        <img :src="persona.imagen" alt="imagen-de-palabras" class="foto" />
        <div class="nombre">
          Palabras
          <br>
          {{ persona.nombre }}
        </div>
        <div class="ver-mas text-center" v-if="activo !== index">
          Ver más
          <br>
          <div class="uve">
            V
          </div>
        </div>
        <div v-if="activo === index" class="texto">{{ persona.texto1 }}</div>
      </div>
      <div class="seccion-wrapper">
        <div class="seccion2 ">
          <p class="texto-justificado">
            {{ persona.textoLargo }}
          </p>
        </div>
        <div class="seccion3">
          <audio controls :src="persona.audio" ref="audioPlayer"></audio>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import Alejandra_Mehech from "@/assets/audio/Alejandra_Mehech.mp3";
import Juan_Cristóbal_Romero from "@/assets/audio/Juan_Cristóbal_Romero.mp3";
import José_Francisco_Yuraszeck from "@/assets/audio/José_Francisco_Yuraszeck.mp3";
import { ref } from "vue";

const personas = [
  {
    nombre: 'Presidenta directorio',
    imagen: require('@/assets/image/presidentadirectorio.jpg'),
    texto1: 'Alejandra Mehech',
    textoLargo: "Se ha vuelto un lugar común decir que Chile ha cambiado.  Jugando con las palabras, creo que ese Chile que cambió es hoy nuestro lugar común y debemos trabajar por hacerlo más justo y digno para todos. El estallido social de 2019, la pandemia y su impacto sanitario, social y económico, el fenómeno migratorio y el envejecimiento de la población son aspectos claves de la transformación real que ha experimentado Chile.  Frente a ese escenario, Hogar de Cristo ha replanteado su quehacer, redefiniendo su estrategia social.  En este breve espacio intentaré explicarlo. El fenómeno migratorio: “Canta en inglés y en aymara”, dice, orgullosa, la tacneña Deysi Escobar, apoderada de nuestro jardín infantil y sala cuna Granito de Arena de Arica, sobre los logros de Emir Mamani, su hijo de 4 años, ya egresado de la educación inicial.En esta etapa, clave para la igualdad de oportunidades futuras, hoy un tercio de los niños y niñas de nuestros jardines infantiles son hijos de extranjeros, en especial en las regiones del Norte.Asimismo, si comparamos los números de atención social de 2022 con los de años anteriores, en las hospederías crece la presencia de venezolanos, colombianos, peruanos, y lo mismo se aprecia en nuestras escuelas de Súmate.Trabajar incluyendo conceptos como la multiculturalidad y la inclusión es clave para superar la desconfianza frente al otro. La etapa final de la vida –la tercera, cuarta y quinta edad, de las que hoy se hablan– se ha prolongado tanto y es tan diversa que hoy nuestra estrategia privilegia las intervenciones mixtas y flexibles que combinan lo residencial de corta estadía con lo ambulatorio, lo domiciliario y lo comunitario.Aquí se enmarcan los programas de atención domiciliaria para adultos mayores, los llamados PADAM, tan valorados en sus efectos benéficos tanto para el cuidado como para el que cuida, sobre todo a partir de la pandemia. Las trayectorias de inclusión y las trayectorias educativas forman parte de nuestra habitualidad, pero el concepto es mucho más amplio.Tiene que ver con que acompañamos a los más vulnerables desde que nacen hasta que mueren y lo hacemos desde Arica a Punta Arenas.Tenemos que dejar de ver la pobreza en etapas: guaguas, niños, jóvenes, adultos, viejos.Debemos entender las trayectorias de vida en su totalidad, intentando que en cada una de esas etapas vitales las personas superen los problemas que les restan oportunidades de futuro. En Hogar de Cristo creemos que no puede haber real inclusión sin una participación incidente de todos.No son tiempos para criterios paternalistas, aplicados desde la expertise o la caridad, sin abrirse a que la ciudadanía es la misma para todos.Las personas –todas, sin distinciones– tienen y pueden desarrollar las habilidades necesarias para lograr lo que se proponen y quienes viven en situación de pobreza, vulnerabilidad, discapacidad son personas como cualquier otra.Esto significa, ser oídas, consideradas y respetadas, porque todos somos protagonistas y constructores de nuestros proyectos vitales.Nuestra nueva estrategia no cree en dar soluciones paliativas a la pobreza, en superar adversidades puntuales.Busca en la evidencia, en la innovación, en el trabajo con otros, soluciones creativas, innovadoras, basadas en la realidad, para transformar las estructuras que perpetúan la fragilidad y limitan las libertades de las personas.Se me queda mucho en el tintero, pero como mujer no puedo dejar de mencionar otro concepto: la perspectiva de género.Somos conscientes de que las mujeres pobres son más pobres que los hombres pobres y debemos trabajar por superar esa desigualdad histórica.Invito a todos nuestros socios, colaboradores y trabajadores a sumarse a estos renovados criterios en nuestro trabajo social, que dan cuenta de los grandes cambios sociales de Chile de la última década.Tal como Alberto Hurtado a fines de los años 40 del siglo pasado interpeló a los chilenos con su pregunta “¿Es Chile un país católico?”, modestamente los llamo a reflexionar sobre este nuevo Chile, que necesita una renovada visión de la pobreza y la vulnerabilidad, para avanzar hacia esa sociedad justa y buena para todos con la que soñamos. Alejandra Mehech Presidente del Directorio",
    audio: Alejandra_Mehech,
  },
  {
    nombre: 'Director ejecutivo',
    imagen: require('@/assets/image/directorejecutivo.jpg'),
    texto1: 'Juan Cristóbal Romero',
    textoLargo: "Esta Memoria está dedicada a quienes han contribuido al desarrollo de esta bellísima obra, a los aportantes, al Estado, a los voluntarios, y, en fin, al “conjunto anónimo de chilenos de corazón generoso”, como el Padre Alberto Hurtado solía llamarlos, que han colaborado en hacer del Hogar de Cristo un milagro permanente. Un examen de esta naturaleza es un modo de involucrar a cada uno de ustedes en el inagotable trabajo del Hogar de Cristo “por crear un clima de verdadero amor y respeto al pobre”, principal anhelo de su fundador. A través de las cifras, noticias y balances aquí expuestos, quisiéramos que ese amor y ese respeto se hagan transparentes y contagiosos. Con alegría, les invitamos a descubrir cómo gracias a la confianza que han depositado en nosotros, al trabajo de cada uno de nuestros más tres mil trabajadores, setenta mil involucrados con la causa, al aporte de los trescientos cuarenta mil socios y a la colaboración del Estado, pudimos cumplir los propósitos trazado para el año. Durante el año 2022, las Fundaciones Hogar de Cristo atendieron a más de 43.914 personas en situación de pobreza a través de sus 258 programas entre Arica y Punta Arenas. Un logro emocionante para todos quienes trabajamos en el Hogar de Cristo fue el haber sido incluidos por segundo año consecutivo en el ranking de las mejores empresas para trabajar en Chile que realiza la consultora Great Place To Work 2021. Asimismo, nuestra querida Francisca Elgueta, profesora del colegio Betania de Fundación Súmate, fue la ganadora del Global Teacher Prize Chile 2022. En materia de incidencia pública, logramos que el Senado promulgara la ley que tipifica la explotación sexual de niñas, niños y adolescentes (NNA), un antiguo anhelo del quienes trabajamos en la restitución de los derechos en infancia. No puedo dejar de destacar también el inicio de la construcción de la Hospedería de Osorno. Finalmente, 2022 será recordado como el año en que se lanzó la nueva Estrategia Social del Hogar de Cristo, que busca fortalecer las trayectorias de inclusión social de nuestros participantes, por medio de servicios ambulatorios y domiciliarios. Aprovecho de animarlos a reforzar su colaboración hacia esta hermosa causa por la justicia social. La situación económica está afectando especialmente a las personas más pobres de nuestro país, y son muchas las necesidades que se siguen sumando a las ya recurrentes. Al igual que para cualquier familia en Chile, pero especialmente aquellas con más dificultades, el Hogar de Cristo ha debido enfrentar alzas en los precios de alimento, combustibles, servicios sanitarios y otros productos esenciales que desafían nuestra economía diaria. Necesitamos más que nunca contar con ustedes. Juan Cristóbal Romero Director Ejecutivo",
    audio: Juan_Cristóbal_Romero,
  },
  {
    nombre: 'Capellán general',
    imagen: require('@/assets/image/capellan.png'),
    texto1: 'José Francisco Yuraszeck s.j.',
    textoLargo: "Una vez más hacemos un alto en el camino y nos detenemos a mirar los pasos que hemos andando en conjunto el año que pasó. El año 2022 será recordado quizás por la postpandemia, con sus dolores y aprendizajes. También porque comenzó un nuevo gobierno en nuestro país, y se desarrolló el proceso Constitucional - aún inconcluso – con grandes desafíos de transformación cultural e institucional. En el Hogar de Cristo quisiera destacar los ajustes a nuestra estrategia social, que consideran nuevos ámbitos de dolor y exclusión: nos hemos movilizado para ampliar nuestra oferta de atención domiciliaria, hacia la reconstrucción o rearticulación del tejido social, atendiendo particularmente a personas mayores con creciente nivel de dependencia en sus casas. Destaco también que hemos continuado con la serie “Del Dicho al Derecho”, esta vez promoviendo un modelo de inclusión integral para personas en situación de calle. Se trata de insistir en mirar la evidencia para transformar lo que hacemos, invitando a otros a colaborar, a diseñar mejores políticas públicas, y desde los valores que nos inspiran, asumir con cariño e inteligencia los nuevos desafíos de inclusión.En el ámbito más propiamente interno quisiera destacar dos iniciativas, y un acento estratégico que las cobija. La mesa Inclusive busca promover que seamos realmente un lugar inclusivo, en que toda persona se sienta bienvenida y con posibilidades de aportar su talento y capacidades personales y profesionales. Por otra parte la nueva política de Cuidado de Equipos busca reconocer que para hacer el bien tenemos que estar bien: tantas veces el “dar hasta que duela” al que nos invita nuestro fundador ha hecho que descuidemos nuestra salud física y mental. Ambas iniciativas se enmarcan dentro del pilar estratégico de Organización, que implica a distintas direcciones y equipos.Agradezco de corazón a todas las personas que se han involucrado de distintas maneras en la misión de acoger y convocar del Hogar de Cristo: muchas gracias por ayudarnos a seguir concretando los sueños que nos legara el padre Hurtado de hacer que nuestro Chile sea cada vez más digno y justo. ¡Muchas gracias!José Fco. Yuraszeck Krebs, S.J.Capellán General",
    audio: José_Francisco_Yuraszeck,
  },
]

const activo = ref(-1)

const toggleSecciones = (index) => {
  if (activo.value === index) {
    activo.value = -1
  } else {
    activo.value = index
  }
}
</script>


<style scoped>

.texto-justificado {
  text-align: justify;
  font-size: 0.8em;
  margin-top: 0.3rem;
}

.container:not(.active) .seccion-wrapper {
  flex: 0;
  visibility: hidden;
}

.container-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.container {
  margin-bottom: 10%;
  justify-content: center;
  display: flex;
  height: 350px;
  width: 20%;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  border-radius: 0;
  overflow: hidden;
  transition: all 1s ease;
}



.container.active {
  width: 100%;
}

.seccion1 {
  border-radius: 5px;
  background-color: rgb(245, 245, 245, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 1rem;
}

.foto {
  width: 150px;
  height: 150px;
  border-radius: 10px;
  object-fit: cover;
}

.nombre {
  text-align: center;
  font-family: DINNextRoundedLTPro-Bold, 'DINNextRoundedLTPro Bold';
  font-size: 20pt;
  display: -webkit-box;
  /* Usar el modelo de caja flexible de WebKit */
  -webkit-line-clamp: 2;
  /* Limitar a 2 líneas */
  -webkit-box-orient: vertical;
  /* Orientación vertical del texto */
  overflow: hidden;
  /* Ocultar el texto que excede las 2 líneas */
}

.texto {
  font-family: DINNextRoundedLTPro-Bold, 'DINNextRoundedLTPro Bold';
  font-size: 12pt;
}

.ver-mas {
  font-family: DINNextRoundedLTPro-Light, 'DINNextRoundedLTPro Light';
  font-size: 10pt;

}

.uve {
  font-family: DINNextRoundedLTPro-Light, 'DINNextRoundedLTPro Light';
  font-size: 0.7em;
}

.seccion-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 1s ease-out;

}

.seccion2 {
  border-radius: 0% 0% 0% 0%;
  flex: 0 0 80%;
  background-color: whitesmoke;
  overflow-y: auto;
  padding: 1rem;
  min-height: 100px;
  /* Agrega una altura mínima aquí */
}

.seccion3 {
  border-radius: 0% 0% 0% 0%;
  flex: 1;
  background-color: whitesmoke;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Añade un media query para pantallas con un ancho máximo de 768px */
@media (max-width: 768px) {
  .container-wrapper {
    /* Cambia de flex-wrap: nowrap a flex-wrap: wrap */
    flex-wrap: wrap;
  }

  .container {
    /* Ajusta el ancho del contenedor al 100% */
    width: 100%;
  }

  .container.first {
    margin-left: 0;
  }

  .container.last {
    margin-left: 0;
  }

  .container {
    margin-left: 0%;
  }

  .container.last {
    margin-right: 0%;
  }

  .container.active {
    width: 100%;
  }

}
</style>